"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var socialIconSvg_1 = require("./socialIconSvg");
require("./SocialIcon.css");
var classnames_1 = __importDefault(require("classnames"));
var SocialIcon = function (_a) {
  var _b;
  var icon = _a.icon,
    className = _a.className,
    style = _a.style,
    _c = _a.size,
    size = _c === void 0 ? "1em" : _c,
    _d = _a.inline,
    inline = _d === void 0 ? false : _d,
    restProps = __rest(_a, ["icon", "className", "style", "size", "inline"]);
  var transform = "".concat((_b = style === null || style === void 0 ? void 0 : style.transform) !== null && _b !== void 0 ? _b : "", " ").concat(inline ? "translateY(0.125em)" : "").trim() || undefined;
  var width = size;
  var height = size;
  return (0, jsx_runtime_1.jsx)("span", __assign({
    className: (0, classnames_1.default)("vsx-social-icon", className),
    style: __assign(__assign({}, style), {
      width: width,
      height: height,
      transform: transform
    })
  }, restProps, {
    children: socialIconSvg_1.socialIconSVG[icon]
  }));
};
exports.SocialIcon = SocialIcon;